import { checkConcaternateAttr } from './concatenateAttributeCheck';

export const getAttributeLabel = (attributes, attributeName) => {
	const attributeObj = attributes.find((item) => item.name === attributeName);
	if (!attributeObj) return null;

	let label = attributeObj.labeledValue;
	if (!checkConcaternateAttr(attributeName, label)) {
		label = attributeObj.value;
	}
	return label;
};
